import { useState, useEffect, useRef } from 'react';
import { ChatMessage } from '../lib/types';
import { useLocation } from 'react-router-dom';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef<() => void>(() => {});

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const intervalId = setInterval(tick, delay);
      return () => clearInterval(intervalId);
    }
  }, [delay]);
}


export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

// Function to set initial chat history based on the agent
export const initializeChatHistory = (agent: string) => {
  const getDefaultMessages = (): ChatMessage[] => {
    switch (agent) {
      case 'felix':
        return [
          {
            entity: 'ai',
            content: "Hi there, I'm Felix! How can I assist you today?",
          },
          {
            entity: 'ai',
            content:
              "Please use the navigation below, or simply ask me anything that's on your mind",
            HideIcon: true,
          },
        ];
      case 'glc':
        return [
          {
            entity: 'ai',
            content: "Hi there, I'm the Innovator! How can I assist you today?",
          },
          {
            entity: 'ai',
            content:
              "Please use the navigation below, or simply ask me anything that's on your mind",
            HideIcon: true,
          },
        ];
      case 'mair':
      case 'mair-gpt':
        return [
          {
            entity: 'ai',
            content: "Hi there, I'm MAIR. How can I assist you?",
          },
          {
            entity: 'ai',
            content:
              "Please use the navigation below, or simply ask me anything that's on your mind",
            HideIcon: true,
          },
        ];
      case 'robin':
        return [
          {
            entity: 'ai',
            content: "Hi there, I'm Robin. How can I assist you?",
          },
          {
            entity: 'ai',
            content:
              "Please use the navigation below, or simply ask me anything that's on your mind",
            HideIcon: true,
          },
        ];
      case 'ny_genai':
      case 'oracle':
      case 'sxsw':
        return [
          {
            entity: 'ai',
            content: "Hi there, I'm Laila! How can I assist you?",
          },
          {
            entity: 'ai',
            content: 'You can ask me questions, or navigate through the app.',
            HideIcon: true,
          },
        ];
      case 'shell':
        return [
          {
            entity: 'ai',
            content: "Hi there, I'm Shell Spark! How can I assist you?",
          },
          {
            entity: 'ai',
            content: "Please use the navigation below, or simply ask me anything that's on your mind",
            HideIcon: true,
          },
        ];
      default:
        return [
          {
            entity: 'ai',
            content: "Hi there, I'm Spark! How can I assist you?",
          },
          {
            entity: 'ai',
            content:
              "Please use the navigation below, or simply ask me anything that's on your mind",
            HideIcon: true,
          },
        ] as ChatMessage[];
    }
  };

  return getDefaultMessages();
};
